export default __webpack_public_path__ + "static/media/2.354ae0cc.png";